<template>
  <div class="metric__status d-flex flex-column align-items-center" style="flex-basis: 50%">
    <font-awesome-icon
      icon="user"
      size="lg"
      :class="`mb-2 status__${statusClass}`"
      :style="{ color: `var(--${colorClass})` }"
    />

    <div
      class="text__status-count font-weight-bold mb-1"
      :class="`text__${statusClass}-status-count`"
    >
      {{ statusCount }}
    </div>

    <p class="text__status-name text-dark text-center">
      {{ statusText }}
    </p>
  </div>
</template>

<script>
import kebabCase from 'lodash';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

export default {
  name: 'BaseAssessmentStatusMetric',

  components: { FontAwesomeIcon },

  props: {
    colorClass: {
      type: String,
      require: true,
      default: ''
    },
    statusCount: {
      type: Number,
      require: true,
      default: 0
    },
    statusText: {
      type: String,
      require: true,
      default: ''
    }
  },

  computed: {
    statusClass() {
      return kebabCase(this.statusText);
    }
  }
};
</script>
